import { Component, OnInit, Renderer2, OnDestroy, AfterViewInit, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Validators } from "@angular/forms";
import { AuthService } from "../../service/auth-service/auth.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { sweetAlert } from "../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { SocketService } from "src/app/service/socket-service/socket-service.service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { environment } from "src/environments/environment";
import { AssigTripsService } from "src/app/service/assigntrips-service/assigntrips-service";
import { PublicOperationsServiceService } from "../assigned-trips/public-operation/public-operations-service/public-operations.service";
import { PlacementAuthService } from "../../service/placement-auth-service/placement-auth.service";


@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.css"],
})
export class SignInComponent implements OnInit, OnDestroy {
  success: boolean;
  passwordToggleFlag = true;
  signInForm: FormGroup;
  submitted = false;
  isStaff = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private sharedDataService: SharedDataService,
    private socket: SocketService,
    private router: Router,
    private operationService: PublicOperationsServiceService,
    private placementAuthService: PlacementAuthService

  ) { }

  ngOnInit() {
    this.authService.removeMFA();
    
    this.signInForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
    });

  }



  get form() {
    return this.signInForm.controls;
  }

  togglePasswordType() {
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  onSignIn() {

    let roles;

      if (this.isStaff) {
        roles = 'corporateapp';
      } else {
        roles = 'cooperate';
      }

      let payload = {...this.signInForm.value , roles}


    this.submitted = true;
    if (this.signInForm.invalid) {
      return;
    }

    this.authService
      .login(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.success) {
              if (data.mfaRequired) {
            this.authService.setMFA(data.mfaToken);
            this.router.navigate(['/verify-mfa']);
          } else {
          this.authService.setToken(data.token);
          this.operationService.removeToken();
          this.sharedDataService.saveUser(data.user);
          if (data.user && data.user.allowPlacement === true) {
            this.placementAuthService.login(data.user).subscribe(
              token => console.log('Placement auth initialized from Sign-In successfully'),
              err => console.error('Placement auth initialization from Sign-In failed', err)
            );
          }
          this.socket.connectSocket();
                this.router.navigateByUrl('/');
         }
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  ngOnDestroy(): void {

  }


}
